import type React from 'react';

interface RewardIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
}

export function RewardIcon({ size = 24, ...props }: RewardIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        d="M2 7.00028V9.00024H18V7.00028H2ZM20 9.00024C20 10.1048 19.1046 11.0002 18 11.0002H2C0.89543 11.0002 0 10.1048 0 9.00024V7.00028C0 5.89574 0.89543 5.00033 2 5.00033H18C19.1046 5.00033 20 5.89574 20 7.00028V9.00024Z"
        fill="currentColor"
      />
      <path
        d="M9 19V6.00031C9 5.44803 9.44772 5.00033 10 5.00033C10.5523 5.00033 11 5.44803 11 6.00031V19C11 19.5523 10.5523 20 10 20C9.44772 20 9 19.5523 9 19Z"
        fill="currentColor"
      />
      <path
        d="M2 17.0001V10.0002C2 9.44795 2.44772 9.00024 3 9.00024C3.55228 9.00024 4 9.44795 4 10.0002V17.0001L4.00488 17.0987C4.02757 17.3277 4.12883 17.5429 4.29297 17.7071C4.48051 17.8946 4.73478 18 5 18H15C15.2652 18 15.5195 17.8946 15.707 17.7071C15.8946 17.5195 16 17.2653 16 17.0001V10.0002C16 9.44795 16.4477 9.00024 17 9.00024C17.5523 9.00024 18 9.44795 18 10.0002V17.0001C18 17.7957 17.6837 18.5585 17.1211 19.1211C16.5585 19.6837 15.7957 20 15 20H5C4.20435 20 3.44152 19.6837 2.87891 19.1211C2.3163 18.5585 2 17.7957 2 17.0001Z"
        fill="currentColor"
      />
      <path
        d="M16 3.49992C15.9999 3.10227 15.8417 2.7206 15.5605 2.4394C15.2793 2.15824 14.8977 1.99996 14.5 1.99996C14.4942 1.99996 14.4882 2.00006 14.4824 1.99996C13.8758 1.98944 13.1903 2.27926 12.5303 3.01263C11.8652 3.75171 11.3049 4.86312 10.9717 6.23619C10.8628 6.68457 10.4614 6.99985 10 6.99985C9.53858 6.99985 9.13717 6.68457 9.02832 6.23619C8.69511 4.86312 8.13483 3.75171 7.46973 3.01263C6.80968 2.27926 6.1242 1.98944 5.51758 1.99996C5.51177 2.00006 5.50581 1.99996 5.5 1.99996C5.10228 1.99996 4.72074 2.15824 4.43945 2.4394C4.15825 2.7206 4.00012 3.10227 4 3.49992C4 3.89774 4.15815 4.28013 4.43945 4.56142C4.72073 4.84255 5.1023 4.99989 5.5 4.99989C6.05214 4.99989 6.49976 5.4478 6.5 5.99987C6.5 6.55214 6.05228 6.99985 5.5 6.99985C4.57187 6.99985 3.68174 6.63165 3.02539 5.97546C2.36901 5.31909 2 4.42816 2 3.49992C2.00012 2.57184 2.36912 1.68163 3.02539 1.02537C3.68175 0.369142 4.57185 0 5.5 0V0.00195308C6.81588 -0.0151459 8.01488 0.629044 8.95605 1.67477C9.34998 2.11248 9.69852 2.61942 10 3.17864C10.3015 2.61942 10.65 2.11248 11.0439 1.67477C11.9851 0.629044 13.1841 -0.0151459 14.5 0.00195308V0C15.4282 0 16.3183 0.369142 16.9746 1.02537C17.6309 1.68163 17.9999 2.57184 18 3.49992C18 4.42816 17.631 5.31909 16.9746 5.97546C16.3183 6.63165 15.4281 6.99985 14.5 6.99985C13.9477 6.99985 13.5 6.55214 13.5 5.99987C13.5002 5.4478 13.9479 4.99989 14.5 4.99989C14.8977 4.99989 15.2793 4.84255 15.5605 4.56142C15.8419 4.28013 16 3.89774 16 3.49992Z"
        fill="currentColor"
      />
    </svg>
  );
}
